import { useCallback, useEffect, useMemo, useRef } from 'react'
import { later } from '~/utils'

const useRequestAbort = () => {
  const abortController = useRef()

  const abort = useCallback(() => abortController.current?.abort(), [])
  const create = useCallback(async () => {
    abort()
    await later()
    abortController.current = new AbortController()
    return abortController.current.signal
  }, [abort])

  useEffect(() => () => abort(), [abort])

  return useMemo(
    () => ({
      abort,
      create,
    }),
    [abort, create]
  )
}

export default useRequestAbort
